require('../../modules/es6.object.get-own-property-descriptor');

var $Object = require('../../modules/_core').Object;

module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};